module.exports = __webpack_public_path__ + "static/media/endosee-accessories-thumb@2x.e4010c46.jpg";